import React, { useEffect, useRef } from 'react';
import style from 'styled-components';

interface FormCharInputProps {
    count: number;
    inputRegex: RegExp;
    autoFocus: boolean;
    input: { value: string, onChange: any };
}

export const FormCharInput: React.FunctionComponent<FormCharInputProps> = ({ count, inputRegex, autoFocus, input }) => 
{
    const characterArray = (!Array.isArray(input.value) || (input.value.length !== count)) ? Array(count).fill(null) : input.value;

    const inputElements = useRef({});

    useEffect(() => 
    {
        if (autoFocus) 
        {
            //@ts-ignore
            inputElements.current['input0'].focus();
        }

        if (!Array.isArray(input.value) && input.value.length) 
        {
            const val = input.value.padEnd(count);

            for (const i in val.split('')) 
            {
                //@ts-ignore
                inputElements.current[`input${i}`].value = val[i];
            }
        }
    }, []);

    //@ts-ignore
    const handleChange = ({ target }) => 
    {
        if (target.value.match(inputRegex)) 
        {
            focusNextChar(target);
            //@ts-ignore
            setModuleOutput(target);
        }
        else 
        {
            target.value = characterArray[target.name.replace('input', '')];
        }
    };

    //@ts-ignore
    const handleKeyDown = ({ target, key }) => 
    {
        if (key === 'Backspace') 
        {
            if (target.value === '' && target.previousElementSibling !== null) 
            {
                target.previousElementSibling.value = '';
                focusPrevChar(target);
            }
            else 
            {
                target.value = '';
            }
            //@ts-ignore
            setModuleOutput(target);
        }
        else if (key === 'ArrowLeft') 
        {
            focusPrevChar(target);
        }
        else if (key === 'ArrowRight') 
        {
            focusNextChar(target);
        }
    };

    //@ts-ignore
    const handleFocus = ({ target }) => 
    {
        const el = target;
        // eslint-disable-next-line no-undef
        setTimeout(function () 
        {
            el.select();
        }, 0);
    };

    //@ts-ignore
    const focusPrevChar = target => 
    {
        if (target.previousElementSibling !== null) 
        {
            target.previousElementSibling.focus();
        }
    };

    //@ts-ignore
    const focusNextChar = target => 
    {
        if (target.nextElementSibling !== null) 
        {
            target.nextElementSibling.focus();
        }
    };

    const setModuleOutput = () => 
    {
        const updatedCharacters = characterArray.map((character, number) => 
        {
            //@ts-ignore
            return inputElements.current['input' + number].value;
        });

        input.onChange(updatedCharacters.join(''));
    };

    return (
        <>
            {characterArray.map((_, i) =>
                <CharInput
                    key={i}
                    handleKeyDown={handleKeyDown}
                    handleFocus={handleFocus}
                    handleChange={handleChange}
                    name={`input${i}`}
                    //@ts-ignore
                    inputRef={el => 
                    {
                        if (!el) return;
                        //@ts-ignore
                        inputElements.current[el.name] = el;
                    }
                    }
                />
            )}
        </>
    );
};

interface CharInputProps {
    handleKeyDown: any;
    handleChange: any;
    handleFocus: any;
    name: string;
    inputRef: any;
}

export const CharInput: React.FunctionComponent<CharInputProps> = ({ handleKeyDown, handleChange, handleFocus, name, inputRef }) => (
    //@ts-ignore
    <Input
        autoComplete="off"
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onFocus={handleFocus}
        name={name}
        maxLength={1}
        ref={inputRef}
    />
);

const Input = style.input`
    text-align: center;
    outline: none;
    border: none;
    border-radius: 8px;
    width: 28px;
    height: 33px;
    background-color: white;
    font-size: 12px;
    font-family: 'SofiaPro-Regular';
    margin-right: 3px;
    
    @media only screen and (min-width: 1900px) {
    font-size: 14px;
    }

    ::placeholder {
        opacity: 0.2;
    }
`;